import CircularProgress from '@mui/material/CircularProgress';

const Loader = ({ message }) => {
  return (
    <div>
      <div className='overlay'></div>
      <div className='spanner show' style={{ zIndex: '11111111111111111111111111111' }}>
        <div className='d-flex flex-column justify-center align-center loading-spinner'>
          <CircularProgress style={{ color: 'black' }} />
          <span className={`mt-4 ${message ? 'f-13' : ''}`}>{message || 'Loading...'}</span>
        </div>
      </div>
    </div>
  );
};

export default Loader;
